
import TalkMultihospdep from './index.vue'

TalkMultihospdep.install = function (Vue) {
  Vue.component(TalkMultihospdep.name, TalkMultihospdep)
}

export default TalkMultihospdep